import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { HealthCheckPingResults } from '../../../../../express-tRPC/src/lib/types/shared-app-interfaces';
import { TrpcService } from '../../services/trpc/trpc.service';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {

  versionInfo: any[] = [];
  isLoading: boolean = false;
  healthCheckResults: HealthCheckPingResults | null = null;
  isPingLoading: boolean = false;
  pingError: string | null = null;

  constructor(
    private messageService: MessageService,
    private trpcService: TrpcService
  ) {}

  ngOnInit(): void {
    this.loadVersionInfo();
    this.checkBackendHealth();
  }

  loadVersionInfo(): void {
    this.isLoading = true;

    // Collect version information specific to ng-rpc
    this.versionInfo = [
      { name: 'Application Version', value: environment.version },
      { name: 'Active File', value: environment.activeFile },
      { name: 'Build Mode', value: environment.buildMode },
      { name: 'API Endpoint', value: environment.TRPC_ENDPOINT_URL },
      { name: 'Node Endpoint', value: environment.NODE_ENDPOINT_URL },
      { name: 'Site URL', value: environment.SITE_URL },
    ];

    this.isLoading = false;
  }

  checkBackendHealth(): void {
    this.isPingLoading = true;
    this.pingError = null;

    this.trpcService.trpc.healthcheck.ping.query()
      .then((response: any) => {
        this.healthCheckResults = response;
        this.isPingLoading = false;
      })
      .catch((error: any) => {
        console.error('Error fetching health check data:', error);
        this.pingError = 'Failed to connect to backend server';
        this.isPingLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Connection Error',
          detail: 'Could not retrieve health check information from the backend'
        });
      });
  }

  refreshHealthCheck(): void {
    this.checkBackendHealth();
  }
}
